var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-scrollbar",
    { attrs: { "wrap-class": "scrollbar-wrapper" } },
    [
      _c("img", {
        staticStyle: { width: "100%" },
        attrs: { src: "data:image/jpg;base64," + _vm.logo }
      }),
      _vm._v(" "),
      _c(
        "el-menu",
        {
          attrs: {
            "show-timeout": 200,
            "default-active": _vm.$route.path,
            collapse: _vm.isCollapse,
            mode: "vertical",
            "background-color": "#304156",
            "text-color": "#bfcbd9",
            "active-text-color": "#409EFF"
          }
        },
        _vm._l(_vm.permission_routers, function(route) {
          return _c("sidebar-item", {
            key: route.path,
            attrs: { item: route, "base-path": route.path }
          })
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }